import { Injectable } from '@angular/core';
import { AuthModule } from '../auth.module';

@Injectable({providedIn:'root'})
export class VerifyEmailService {
  email?: string;
}
